import React from 'react'
import SummaryOptions from 'features/Programs/Summary/components/SummaryOptions'
import { Car } from 'core-system/Icons/modeTypes'
import SummaryBudget from './components/SummaryBudget'
import SummaryContainerBox from 'features/Programs/Summary/components/SummaryContainerBox'
import wordings from '../Shared/wordings.json'
import palette from 'core-system/Themes/palette'

interface GrhSummaryProps {
  transaction: number
  uses: number
  activeOptions: {
    rideshare: boolean
    localTaxi: boolean
  }
  activeMerchantIds: {
    rideshare: string[]
    localTaxi: string[]
  }
}

const QtfSummary = ({
  transaction = 0,
  uses = 0,
  activeOptions = {
    rideshare: false,
    localTaxi: false,
  },
  activeMerchantIds = {
    rideshare: [],
    localTaxi: [],
  },
}: GrhSummaryProps) => {
  return (
    <SummaryContainerBox title={wordings.grh.title}>
      <SummaryOptions
        icon={<Car color={palette.secondary.purple600} />}
        activeOptions={[
          {
            type: 'rideshare',
            activeMerchantIds: activeMerchantIds.rideshare,
            active: activeOptions.rideshare,
          },
          {
            type: 'localTaxi',
            activeMerchantIds: activeMerchantIds.localTaxi,
            active: activeOptions.localTaxi,
          },
        ]}
      />
      <SummaryBudget
        title='Budget'
        lines={[
          {
            title: 'Maximum Authorization',
            value: transaction,
          },
          {
            title: 'Number of Transactions',
            value: uses,
          },
        ]}
      />
    </SummaryContainerBox>
  )
}

export default React.memo(QtfSummary)
